import { render, staticRenderFns } from "./CreateTemplate.vue?vue&type=template&id=bbd0a84e&scoped=true"
import script from "./CreateTemplate.vue?vue&type=script&lang=js"
export * from "./CreateTemplate.vue?vue&type=script&lang=js"
import style0 from "./CreateTemplate.vue?vue&type=style&index=0&id=bbd0a84e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbd0a84e",
  null
  
)

export default component.exports